// function debounce(func, delay) {
//   let timer;
//   return (...args) => {
//     if (timer) {
//       clearTimeout(timer);
//     }
//     // console.log('-- ' + delay)
//     timer = setTimeout(() => {
//       func.apply(this, args);
//     }, delay);
//   };
// }
function debounce(func, delay) {
  let timer = null;
  let args = null;

  const later = () => {
    func.apply(this, args);
    timer = args = null;
  };

  return function (...newArgs) {
    args = newArgs;
    clearTimeout(timer);
    timer = setTimeout(later, delay);
  };
}

function cssVhToPxByWindowHeight(style, windowHeight) {
  // 因为 iOS Safari 存在 vh 不准确的问题，将 css 字符串中 vh 根据实际高度转换为 px 。
  let reg = {};
  let newStyle = style;
  // 100
  // 100.12
  // 0.12
  // .12
  let style_temp = style.replace(new RegExp('(.i_|#i_).*?{', 'g'), '');
  var res = style_temp.match(
    new RegExp('([0-9]{1,})?(\\.[0-9]{1,})?([0-9]{1,}\\.[0-9]{1,})?vh', 'g')
  );
  if (!res) return false;
  let arr = [];
  res.forEach((str) => {
    if (str !== 'vh') {
      arr.push(str);
    }
  });
  arr.sort((a, b) => {
    return a.length - b.length;
  });
  arr.reverse();
  arr = [...new Set(arr)];
  arr.forEach((vhStr) => {
    reg = new RegExp(vhStr, 'g');
    let vh = vhStr.substring(0, vhStr.length - 2);
    let px = ((windowHeight / 100) * vh).toFixed(2);
    // console.log(vhStr, vh, px);
    newStyle = newStyle.replace(reg, '' + parseFloat(px) + 'px');
  });
  return newStyle;
}

function extractStyle(html, start, end, content) {
  let reg = new RegExp(start + '(.*?)' + end, 'g');
  let style = html.match(reg);
  if (!style) return html;
  let newHtml = html.replace(reg, '__STYLE__');
  reg = new RegExp('__STYLE__', 'g');
  html = newHtml.replace(reg, start + content + end);
  return html;
}

function extractStyleAndChange(html, start, end, height) {
  let reg = new RegExp(start + '(.*?)' + end, 'g');
  let style = html.match(reg);
  if (!style) return html;
  let newHtml = html.replace(reg, '__STYLE__');
  let oldStyle = style[0].substring(start.length, style[0].length - end.length);
  let newStyle = cssVhToPxByWindowHeight(oldStyle, height);
  if (newStyle) {
    reg = new RegExp('__STYLE__', 'g');
    html = newHtml.replace(reg, start + newStyle + end);
  }
  return { html, oldStyle, newStyle };
}

function gtag(g, a, b, c) {
  if (typeof window === 'undefined') return;
  if (!g) {
    console.warn('no gtag!');
    return;
  }
  if (c) {
    g(a, b, c);
  } else if (b) {
    g(a, b);
  } else {
    g(a);
  }
}

function getRequest(path) {
  var e =
      typeof window !== 'undefined' ? decodeURI(window?.location.search) : path,
    t = {};
  if (-1 != e.indexOf('?')) {
    let i = e.substring(1);
    let strs = i.split('&');
    for (var n = 0; n < strs.length; n++) {
      let kv = strs[n].split('=');
      if (kv[1]) t[strs[n].split('=')[0]] = kv[1]; // 屏蔽空字段
    }
  }
  return t;
}

export {
  debounce,
  cssVhToPxByWindowHeight,
  extractStyle,
  extractStyleAndChange,
  gtag,
  getRequest,
};
